import React, { ComponentProps, FunctionComponent } from "react";

const PhoneChatIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 23 22",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M7.15516 15.1566C8.48133 16.2562 10.2053 17.8872 11.4597 16.6893L11.9696 16.1579C12.2095 15.9076 12.547 15.7616 12.9021 15.7536C13.2583 15.7467 13.6011 15.8788 13.8534 16.1192L15.92 18.0958C17.0852 19.3722 15.3489 20.3765 14.3425 21.203C11.4006 23.3138 7.64319 20.8951 4.30855 17.8784C1.15255 14.6848 -1.37203 11.1022 0.832728 8.28216C1.69365 7.31765 2.74876 5.65995 4.08124 6.77332L6.14785 8.74999H6.14889C6.40021 8.99037 6.53832 9.31916 6.53002 9.65886C6.52275 9.99956 6.37009 10.3214 6.10736 10.5518L5.55178 11.0396C4.29935 12.2355 6.00658 13.8913 7.15516 15.1566ZM12.7578 11.8201L10.0381 12.3982L10.6488 9.79079C6.58726 3.33623 15.2691 -3.36549 21.0225 1.89112C26.5183 7.39897 19.5146 15.692 12.757 11.8203L12.7578 11.8201ZM13.409 5.60411C12.9614 5.61802 12.6062 5.96965 12.6062 6.39876C12.6062 6.82687 12.9614 7.1785 13.409 7.1934C13.8566 7.17751 14.2107 6.82687 14.2107 6.39876C14.2107 5.96965 13.8566 5.61901 13.409 5.60411ZM16.3055 5.60411C15.8579 5.61802 15.5027 5.96965 15.5027 6.39876C15.5027 6.82687 15.8579 7.1785 16.3055 7.1934C16.7531 7.17751 17.1072 6.82687 17.1072 6.39876C17.1072 5.96965 16.7531 5.61901 16.3055 5.60411ZM19.1759 5.60411C18.7283 5.61802 18.3732 5.96965 18.3732 6.39876C18.3732 6.82687 18.7283 7.1785 19.1759 7.1934C19.6235 7.17751 19.9777 6.82687 19.9777 6.39876C19.9777 5.96965 19.6235 5.61901 19.1759 5.60411Z",
      fill: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(PhoneChatIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
